import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const BATCH_STAGE_VALUES = ['awaiting_mis', 'sent_back', 'confirmed', 'disbursed'] as const;

export const BATCH_STAGE_LABEL: Record<string, string> = {
  awaiting_mis: 'Awaiting MIS',
  sent_back: 'Sent back',
  confirmed: 'Confirmed',
  disbursed: 'Disbursed',
};

export const BATCH_STAGE_TONE: Partial<Record<string, StatusColorTone>> = {
  awaiting_mis: APPROVAL_STATUS_TONE.pending,
  sent_back: APPROVAL_STATUS_TONE.rejected,
  confirmed: APPROVAL_STATUS_TONE.recommended,
  disbursed: APPROVAL_STATUS_TONE.approved,
};
